// extracted by mini-css-extract-plugin
export default {"footerLink":"FooterLink_footerLink__hAZDG","list":"FooterLink_list__hgSZx","item":"FooterLink_item__7LuGT"};